module.exports = __webpack_public_path__ + "static/logo-kk4d-5af2487df9f13b5860968149098804e3.png";